import { BoxProps, TextProps } from '@jfs/ui-new'

const styles = {
  container: {
    paddingVertical: 16,
    ph: 24,
    w: '100%',
    paddingHorizontal: 'MEDIUM_BIG',
    bg: 'WHITE',
    underlayColor: 'TRANSPARENT',
    flexDirection: 'row',
    justifyContent: 'space-between',
    h: 68,
  } as BoxProps,
  dotView: {
    height: 6,
    maxWidth: 6,
    borderRadius: 4,
    bg: 'PENCIL_GREY',
    alignSelf: 'center',
    marginHorizontal: 8,
    opacity: 0.2,
  } as BoxProps,
  labelText: (isDarkText: boolean) =>
    ({
      color: isDarkText ? 'BLACK' : 'PRIMARY_GREY',
      fontSize: isDarkText ? 14 : 12,
    } as TextProps),
  labelTextCushioned: {
    color: 'PRIMARY_GREY',
    fontSize: 12,
  } as TextProps,
  righViewWrapper: {
    alignItems: 'flex-end',
    flex: 1,
  } as BoxProps,
  listFooter: {
    padding: 20,
    bg: 'WHITE',
  } as BoxProps,
}

export { styles }
